import React from "react";
import PropTypes from "prop-types";
import { DropdownButton, MenuItem } from "react-bootstrap";
import { FormattedMessage, injectIntl, intlShape } from "react-intl";

/*
 *	const rueckfuehrungsIndex = [
 *		{ i18n_key: "Oil circulation", value: 0 },
 *		{ i18n_key: "Air pipes", value: 1 }
 *	];
 */

const genAlmigDropdownItem = (item, i, setValue) => (
	<MenuItem key={i} onClick={() => { setValue(item.value); }}>
		<FormattedMessage id={item.i18n_key} />
	</MenuItem>
);

export const genAlmigDropdownItems = (list, setValue) => (
	list.map((item, i) => {
		return genAlmigDropdownItem(item, i, setValue);
	})
);

export const genAlmigDropdownTitle = (list, value) => {
	let item = list.find(item => item.value === value);
	return <FormattedMessage id={item.i18n_key} />;
};

const AlmigDropdown = props => (
	<DropdownButton id={props.id} title={props.title}>
		{props.children}
	</DropdownButton>
);

AlmigDropdown.propTypes = {
	id: PropTypes.string.isRequired,
	title: PropTypes.node.isRequired,
	children: PropTypes.node,
	intl: intlShape.isRequired
};

export default injectIntl(AlmigDropdown);
